import React from 'react';
const Spinner = (props) => (
    <div className="spinner_parent">
        <div className="spinner">
            <div className="double-bounce1"></div>
            <div className="double-bounce2"></div>
        </div>
    </div>
);

export default Spinner;